import React from 'react';
import {Button } from "antd"

var jieJueList = window.apiObj.jieJueList

var solutionList = []
jieJueList.forEach((element,index) => {
    solutionList.push({
      name: 'block0',
      tag: {
        className: 'content7-tag',
        text: {
          children: (
            <span>
              <p>{element.title}</p>
            </span>
          ),
          className: 'content7-tag-name',
        },
        icon: { children: 'mobile' },
      },
      content: {
        className: 'content7-content',
        text: {
          className: 'content7-text',
          md: 24,
          xs: 24,
          children: (
            <span key={index} >
              <h1 style={{color:'#fff'}}>{element.title}</h1>
              <br/>
              <div dangerouslySetInnerHTML={{ __html: element.description }} />
              <br/>
              <br/>
              {/* href={'#/detail?page=dongtai&type=news&name=行业动态&title='+item.title} */}
              <Button href={'#/a-solution-detail?page=&type=solution&navTitle=解决方案&name='+element.title+'&title='+element.title} >了解更多</Button>
              <br />
              <br />
              <div style={{marginTop:'30px'}}>
                  {/* <img
                    style={{width:'160px',height:'72px',marginRight:"18px"}}
                    src={require('../../static/jjfa/水闸集群解决方案.png')}
                  />
                   <img
                    style={{width:'160px',height:'72px',marginRight:"18px"}}
                   src={require('../../static/jjfa/水闸集群解决方案1.png')}
                  />
                   <img
                    style={{width:'160px',height:'72px',marginRight:"18px"}}
                   src={require('../../static/jjfa/水闸集群解决方案2.png')}
                  /> */}
                   
              </div>
            </span>
          ),
        },
        img: {
          className: 'content7-img',
          children:
            '',
          md: 0,
          xs: 0,
        },
      },
    })
});


export const Feature50DataSource = {
  wrapper: {
    className: 'home-page-wrapper content7-wrapper l5t018xp9g-editor_css',
  },
  page: { className: 'home-page  l5t00re2lwt-editor_css' },
  OverPack: {},
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p style={{color:'#000'}}>解决方案</p>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        children: (
          <span>
            <p style={{color:'#000'}}>针对不同行业属性及规模制定了专业的行业解决方案</p>
          </span>
        ),
      },
    ],
  },
  tabsWrapper: { className: 'content7-tabs-wrapper' },
  block: {
    children: solutionList,
    className: 'ant-tabs',
  },
};
